import React, { useCallback } from 'react';
import AsyncSelect from 'react-select/async';
import TargetingClient from '~/state/Targeting/client';

import fb from '~/api/core/facebook';

// z-index to prevent ad type buttons from
// overlaying dropdown
const customInterestStyling = {
  container: () => ({
    zIndex: 901,
  }),
};

const handleValue = (e, { action, ...rest }) => {
  switch (action) {
    case 'select-option': {
      return TargetingClient.interests.add(rest.option);
    }
    case 'pop-value':
    case 'remove-value': {
      if (rest.removedValue === undefined) return null;
      return TargetingClient.interests.remove(rest.removedValue.id);
    }
    case 'clear': {
      return TargetingClient.interests.clear();
    }
    default: {
      return null;
    }
  }
};


const InterestInput = (props) => {
  const {
    accountId,
  } = props;

  const handleSelect = useCallback((e, data) => handleValue(e, data), [handleValue]);

  const handleLoad = useCallback((query) => {
    const cleanQuery = query.trim().toLowerCase();
    const path = `${accountId}/targetingsearch?q=${cleanQuery}&regulated_categories=["HOUSING"]`;
    return fb(path, 'GET', undefined).then(s => s.data);
  }, [accountId]);

  return (
    <div className="link__row">
      {' '}
      <div className="link__input-container">
        <div className="collage__header">
          <h4>Interests</h4>
          <p>Click on a suggestion from the dropdown box to add an interest</p>
          <AsyncSelect
            isMulti
            components={{
              DropdownIndicator: () => null,
              IndicatorSeparator: () => null,
            }}
            loadOptions={handleLoad}
            getOptionValue={e => e.id}
            getOptionLabel={e => e.name}
            onChange={handleSelect}
            name="Interests"
            placeholder="Enter your interests..."
            styles={customInterestStyling}
          />
        </div>
      </div>
    </div>
  );
};

export default InterestInput;
